/* global $:false,  _:false, localStorage:false  */
;(function () {
  'use strict'

  angular.module('pub.bundle.step5', ['pub.bundle.step5.react']).controller('Step5Ctrl', Step5Ctrl)

  /** @ngInject */
  function Step5Ctrl(
    $timeout,
    $scope,
    $rootScope,
    $q,
    $state,
    $stateParams,
    CollectiblesService,
    SetsService,
    BundleCache,
    BundleService,
    OddsService,
    API,
    UserCache,
  ) {
    var vm = this
    vm.parentId = $stateParams.parentId
    vm.isEvent = $stateParams.event
    vm.isCreate = $stateParams.create
    vm.postId = $stateParams.post
    vm.isChannelBundle = !!$stateParams.channelId
    vm.channelId = $stateParams.channelId
    var sets = []
    var odds = []
    vm.model = {}
    vm.oddsOtherSets = []
    vm.odds = []
    vm.guaranteedAmout = 0
    vm.data = {
      s3: $rootScope.urlS3,
    }

    window.onbeforeunload = function (event) {
      var message = 'Are you sure you want to leave this page?'
      if (event) {
        event.returnValue = message
      }
      return message
    }

    vm.save = function () {
      var cacheStep3 = BundleCache.getStep3()
      var models = []
      var sets = cacheStep3[1]
      var odds2 = cacheStep3[0]

      for (var i = 0; i < sets.length; i++) {
        for (var j = 0; j < sets[i].q.length; j++) {
          sets[i].q[j]['id-b'] = parseInt(sets[i].q[j]['id-b'])
          if (sets[i].q[j].ov !== undefined) {
            sets[i].q[j].o = sets[i].q[j].ov
          }
          models.push({
            id: sets[i].q[j].id,
            'id-b': sets[i].q[j]['id-b'],
            'id-q': sets[i].q[j]['id-q'],
            o: parseInt(sets[i].q[j].o),
            g: sets[i].q[j].g,
          })
        }
      }

      for (var i = 0; i < odds2.length; i++) {
        for (var j = 0; j < odds2[i].q.length; j++) {
          models.push({
            id: odds2[i].q[j].id,
            'id-b': odds2[i].q[j]['id-b'],
            'id-q': odds2[i].q[j]['id-q'],
            o: parseInt(odds2[i].q[j].o),
            g: odds2[i].q[j].g,
          })
        }
      }

      var bundleId = parseInt($stateParams.id)
      OddsService.updateBatch(bundleId, models).then(success, error)

      function success() {
        if (vm.isCreate === 'true' && vm.isEvent === 'true') {
          var channelId = parseInt(localStorage.getItem('channelId'))
          $state.go('pub.channels.posts.edit', {
            parentId: channelId,
            id: vm.postId,
            event: true,
            create: true,
          })
          return
        }

        if (vm.isEvent) {
          $state.go('admin.event')
          return
        }

        toastr.success('Saved!')
        $state.go($state.current, {}, { reload: true })
      }

      function error(result) {
        swal('Should use larger values for odds')
      }
    }

    vm.back = function () {
      if (vm.isEvent) {
        $state.go('admin.event')
        return
      }
      $state.go('pub.bundles', { parentId: $stateParams.parentId })
    }
  }
})()
